// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3k6t5","tabs":"style_tabs__3_RJa","item":"style_item__27L37","active":"style_active__Bdvye","box":"style_box__1HUVN"};